import './sectionBody.scss';

interface ISectionBodyProps {
    children: JSX.Element;
}
const SectionBody: React.FC<ISectionBodyProps> = ({ children }) => {
    return <div className="sectionBody">{children}</div>;
};

export default SectionBody;
